<template>
<div class="py-6 px-4 sm:px-6">

  <div class="prose prose-sm prose-blue">
    <h1 ref="title" class="text-2xl font-semibold mb-0">
      Subscription
    </h1>
  </div>


  <div v-if="loading" class="space-y-2">
    <div 
      v-for="i of 4" :key="i"
      class="w-full bg-gray-100 animate-pulse rounded-lg"
      :class="[`h-` + Math.floor((Math.random() * 10) + 5)]"
    ></div>
  </div>
  <div v-else>
    <div v-if="!activeSubscription">
      
      <div class="relative mt-8 -mx-4 sm:-mx-6">
        <div class="absolute inset-0" aria-hidden="true">
          <div class="absolute inset-y-0 right-0 w-1/2 bg-blue-700" />
        </div>
        <div class="relative mx-auto max-w-7xl">
          <div class="bg-blue-700 py-12 px-6 sm:py-16">
            <div class="mx-auto lg:mx-0">
              
              <!-- <h2 class="text-2xl font-bold text-white sm:text-2xl">
                The Tutor Index
              </h2> -->


              <p class="text-xl text-white font-medium leading-snug max-w-xl">
                A subscription grants you special access to respond to tutoring jobs that are posted to The Tutor Index.
              </p>
              <p class="mt-2 text-sm text-blue-100 leading-snug max-w-xl">
                Rather than waiting for potential clients to first find your profile, then commit to sending you an enquiry, subscribing allows you to be proactive and reach out when jobs come in.
              </p>


              <span class="mt-6 flex items-baseline space-x-2 text-5xl font-bold tracking-tight text-white">
                <span class="text-3xl font-medium text-blue-200">
                  £
                </span>
                <span>
                  2.99
                </span>
                <span class="text-base font-medium text-blue-200">
                  / month
                </span>
              </span>
              <p class="mt-1 text-sm text-blue-200">
                Cancel anytime.
              </p>


              <button type="button" @click="buyMonthlyClicked" class="mt-5 flex items-center justify-center rounded-md border border-transparent bg-white max-w-xs px-10 py-4 text-lg font-semibold leading-6 text-blue-600 hover:bg-blue-50 md:px-12">
                Get Started
              </button>
              <p class="mt-3 text-xs text-blue-300">
                By subscribing to Tutor Index, you acknowledge that you have read and agree to these <a href="/terms-and-conditions" target="_blank" class="underline">terms and conditions</a>.
              </p>

              
              <!-- <p class="mt-10 text-lg font-semibold text-blue-200 sm:tracking-tight">
                Subscribe today and benefit from:
              </p>
              <dl class="mt-5 space-y-10">
                <div v-for="feature in features" :key="feature.name" class="relative">
                  <dt>
                    <div class="absolute flex h-12 w-12 items-center justify-center rounded-md bg-blue-600">
                      <CheckIcon class="h-6 w-6 text-blue-100" style="flex-shrink: 0" aria-hidden="true" />
                    </div>
                    <p class="ml-16 text-lg font-medium leading-6 text-white">
                      {{ feature.name }}
                    </p>
                  </dt>
                  <dd class="mt-1 ml-16 text-sm text-blue-100">
                    {{ feature.description }}
                  </dd>
                </div>
              </dl>

              <p class="mt-16 text-lg text-blue-200 font-semibold leading-snug tracking-tight">
                Purchase an <span class="font-extrabold">annual</span> subscription today and you’ll also receive:
              </p>
              <dt class="mt-5">
                <div class="absolute flex h-12 w-12 items-center justify-center rounded-md bg-blue-600">
                  <CheckIcon class="h-6 w-6 text-blue-100" style="flex-shrink: 0" aria-hidden="true" />
                </div>
                <p class="ml-16 text-lg font-medium leading-6 text-white">
                  Enhanced DBS Check, worth £75
                </p>
              </dt>
              <dd class="mt-1 ml-16 text-sm text-blue-100">
                An industry-standard background check that helps reassure clients you are a trustworthy choice.
              </dd> -->
            </div>
          </div>
          
        </div>
      </div>


      <!-- <TailwindButton @click="buyMonthlyClicked">Buy Monthly</TailwindButton>
      <TailwindButton @click="buyAnnualClicked">Buy Annual</TailwindButton> -->

    </div>
    
    
    <!-- Latest Subcripion -->

    <div v-if="activeSubscription" class="-mx-4 mt-8 px-4 py-8 max-w-xl bg-blue-700 sm:mx-0 sm:px-6 sm:rounded-lg md:flex md:justify-between md:items-start md:space-x-4">
      <div class="">
        <h2 class="text-sm tracking- text-blue-300 uppercase">
          Your current subscription
        </h2>
        <h3 class="mt-5 text-lg font-medium text-white capitalize">
          The Tutor Index {{ activeSubscription.Type.toLowerCase() }}
          -
          {{ activeSubscription.Recurrence === 'MONTHLY' ? 'Monthly' : 'Yearly' }}
        </h3>
        <p class="mt-1 text-4xl text-white font-semibold tracking-tight">
          {{ activeSubscription.EndWhen && activeSubscription.ExistsInStripe ? 'Cancelled' : 'Active' }}
        </p>
        <p v-if="activeSubscription.EndWhen" class="mt-1 text- text-blue-200 font-">
          Ends on: {{ dayjs(activeSubscription.EndWhen).format('Do MMMM YYYY') }}
        </p>
        <p v-else class="mt-1 text- text-blue-200 font-">
          Started on: {{ dayjs(activeSubscription.StartWhen).format('Do MMMM YYYY') }}
        </p>
        <p v-if="activeSubscription.EndWhen" class="mt-3 text-xs text-blue-200">
          You will continue to receive all subscription benefits until your end date has passed.
        </p>
      </div>
      <div class="mt-4 md:mt-12">
        <TailwindButton
          v-if="activeSubscription.ExistsInStripe"
          size="xlarge"
          theme=""
          color=""
          @click="openCustomerPortal(activeSubscription.Id)"
          class="bg-blue-900"
        >
          Manage
        </TailwindButton>
      </div>

      <!-- <p class="mt-8 text-blue-100 text-lg">
        Here’s a little reminder of what you’re getting:
      </p>
      <dl class="mt-1 space-y-2">
        <dt v-for="feature of features" :key="feature.name" class="flex space-x-2 text-blue-100">
          <CheckIcon class="w-5 h-5 text-white" />
          <div class="">
            <span class="block">{{ feature.name }}</span>
            <span class="block text-sm">{{ feature.description }}</span>
          </div>
        </dt>
      </dl> -->
    </div>
    

    <!-- Other Subscriptions -->

    <div v-if="false && historicSubscriptions.length > 0" class="mt-12">

      <h2 class="text-lg font-semibold text-gray-800">
        Your previous subscriptions
      </h2>
      <p class="text-sm text-gray-600">
        View and access your past subscriptions.
      </p>

      <div class="mt-2 max-w-lg space-y-4 divide-y-2 divide-gray-100">
        <div v-for="sub of historicSubscriptions" :key="sub.Id" class="pt-4 flex flex-col justify-between sm:flex-row sm:items-center">
          <div class="flex flex-col space-y-0.5">
            <div class="text-lg text-gray-800 capitalize">
              The Tutor Index {{ sub.Type.toLowerCase() }}
            </div>
            <div class="text-sm text-gray-600">
              {{ sub.Recurrence === 'MONTHLY' ? 'Monthly' : 'Annual' }}
            </div>
            <div class="text-sm text-gray-600">
              {{ dayjs(sub.StartWhen).format('Do MMM ’YY') }} — {{ dayjs(sub.EndWhen).format('Do MMM ’YY') }}
            </div>
          </div>
          <div class="mt-2 sm:mt-0">
            <TailwindButton
              v-if="sub.ExistsInStripe"
              @click="openCustomerPortal(sub.Id)"
              size="xsmall"
              theme="outline"
            >
              View Invoices
            </TailwindButton>
          </div>
        </div>
      </div>

    </div>
  

  </div>

</div>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(utc)
dayjs.extend(advancedFormat)

import { CheckIcon } from '@vue-hero-icons/solid'

import TailwindButton from './TailwindButton.vue'

import SubscriptionService from '../services/SubscriptionServices'
const subscriptionService = new SubscriptionService()

export default {
  components: { 
    TailwindButton, 
    CheckIcon,
  },
  data() {
    return {
      loading: true,
      subscriptions: [],
      dayjs,
      features: [
        { name: 'Search ranking boost', description: 'Appear higher in search results, meaning you are more likely to be seen by prospective clients.' },
        { name: 'Enhanced search result listing', description: 'Stand out from the crowd with a visually enhanced search result listing.' },
        { name: 'Tutor Testimonials', description: 'Add your favourite client testimonials to your profile to help win new business.' },
      ],
      buyMonthly: false,
    }
  },
  methods: {
    async fetchSubscriptions() {
      var response = await subscriptionService.fetchSubscriptions()
      this.subscriptions = response.data
    },
    async buyClicked() {
      return this.buyMonthly
        ? this.buyMonthlyClicked()
        : this.buyAnnualClicked()
    },
    async buyMonthlyClicked() {
      var response = await subscriptionService.getBasicMonthlyPaymentLink()
      window.location = response.data
    },
    async buyAnnualClicked() {
      var response = await subscriptionService.getPlusAnnualPaymentLink()
      window.location = response.data
    },
    async openCustomerPortal(subscriptionId) {
      var response = await subscriptionService.getCustomerPortalUrl(subscriptionId)
      window.location = response.data;
    },
  },
  computed: {
    activeSubscription() {
      return this.subscriptions.find(x => x.EndWhen == null || dayjs(x.EndWhen).isAfter(dayjs.utc()))
    },
    historicSubscriptions() {
      return this.subscriptions.filter(x => x.Id !== this.activeSubscription?.Id)
    },
  },
  mounted() {
    if (this.$route.query.created) {
      // Subscription just created. We *should* be able
      // to let the page load as normal and the new subscription
      // be available. The reason is the user is not auto
    }

    this.fetchSubscriptions().then(() => this.loading = false)
  }
}
</script>

<style lang="scss" scoped>

</style>